import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Space } from 'antd'
import { Outlet, useLocation } from 'react-router-dom'

const CreditBatchesContainer = () => {
  const location = useLocation()
  const isDetailsPage = /^\/credit-batches\/\d+$/.test(location.pathname)

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar
        title={translate(isDetailsPage ? 'creditBatches.detailTitle' : 'navBar.creditBatchesTitle')}
      />
      <Outlet />
    </Space>
  )
}

export default CreditBatchesContainer
